import { render, staticRenderFns } from "./BookItem.vue?vue&type=template&id=2d3f88e6"
import script from "./BookItem.vue?vue&type=script&lang=js"
export * from "./BookItem.vue?vue&type=script&lang=js"
import style0 from "./BookItem.vue?vue&type=style&index=0&id=2d3f88e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports